<template>
	<div class="referral-options">
		<div class="referral-code">
			{{ couponCode }}
		</div>
		<div>
			<button
				@click="referralShareClicked('email')"
				class="button button-auto button-primary-alt"
			>
				<i class="sk-icon-envelope-solid"></i>
			</button>
			<button
				@click="referralShareClicked('sms')"
				class="button button-auto button-primary-alt"
			>
				<i class="sk-icon-sms-solid"></i>
			</button>
		</div>
	</div>
</template>

<style scoped>
.referral-options {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.referral-options .button-primary-alt i {
	font-size: 10px;
}

.referral-options .button-primary-alt:not(:last-child) {
	margin-right: 10px;
}

.referral-code {
	background: var(--gR-white2);
	color: var(--sk-grey3);
	display: inline-block;
	padding: 5px 20px;
	margin-top: 10px;
	font-size: 12px;
	border-radius: 5px;
}
</style>

<script>
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"

export default {
	name: "UserReferral",
	props: {
		couponCode: String
	},
	methods: {
		referralShareClicked(target) {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Referral Share Clicked",
				data: {
					referral_type: target
				}
			})
			eventBus.emit(EventBusEvents.OPEN_SHARE_MODAL, target)
		}
	}
}
</script>